module.exports = __webpack_public_path__ + "static/media/13.ef78436b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/13.png
// module id = 1053
// module chunks = 0